import React, { useState } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';

export default function Table({ columns, data, onEditSave }) {

  const [editableCell, setEditableCell] = useState([]);
  const [editedValue, setEditedValue] = useState('');


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useSortBy, usePagination
  )

  const toggleEdit = (rowIndex, columnId) => {
    const cellKey = `${rowIndex}-${columnId}`;
    if (editableCell === cellKey) {
      setEditableCell(null);
    } else {
      setEditedValue(data[rowIndex][columnId]); // Set the edited value to the current cell's value
      setEditableCell(cellKey);
    }
  };

  const handleSave = (rowIndex, columnId, rowId) => {
    const updatedData = [...data];
    updatedData[rowIndex][columnId] = editedValue;
    // Perform any other save/update logic here
    onEditSave(rowIndex, columnId, editedValue, rowId);
    setEditableCell(null);
  };
  

  // Render the UI for your table
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className={
                    column.isSorted
                      ? column.isSortedDesc
                        ? "desc"
                        : "asc"
                      : ""
                  }
                >{column.render('Header')} </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  const isEditable = cell.column.isEditable;
                  const cellKey = `${i}-${cell.column.id}`;

                  return (
                    <td {...cell.getCellProps()}>
                      {editableCell === cellKey ? (
                        <input
                          type="text"
                          value={editedValue}
                          onChange={e => setEditedValue(e.target.value)}

                          onBlur={() => {
                            if (isEditable) {
                              handleSave(i, cell.column.id, row.original.id)
                            }
                          }}
                        />
                      ) : (
                        <div
                          onClick={() => {
                            if (isEditable) {
                              setEditedValue(cell.value);
                              toggleEdit(i, cell.column.id);
                            }
                          }}
                          className={`editable-cell ${isEditable ? 'editable' : ''}`}
                        >
                          {cell.render('Cell')}
                        </div>
                      )}
                    </td>
                  );
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}
